import Image from "next/image";
import React from "react";
import style from "./author.module.scss";
import { toWebp } from "@/utils/common";
import Link from "next/link";

interface Props {
  data: any;
}
const BlogAuthor: React.FC<Props> = ({ data }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL || "";

  const author = data?.data?.[0]?.attributes?.author_data;

  return (
    <>
      <section className="author  pt-[56px] lg:pt-[60px] xl:pt-[80px] pb-[40px] lg:max-w-[1000px] xl:max-w-[1300px] 2xl:max-w-[1536px] mx-auto lg:pl-[100px] xl:pl-[100px]">
        <div className="container">
          <div>
            <div className="bg-[#B0D9F7] p-[8px_31px] flex items-center lg:mb-[0px] mb-[167px] ">
              <p className="text-center md:text-left text-[#003861] text-[16px] leading-[22.4px] font-[400] w-full">
                More About Author
              </p>
            </div>

            <div
              className={`${style["author-content"]} relative z-[1] p-[65px_20px_56px_20px] lg:p-[40px_40px_40px_100px]`}
            >
              <div
                className="
                      mt-[-150px] lg:mt-0
                      author-img absolute
                      top-0 left-1/2
                      -translate-x-1/2
                      lg:top-1/2 lg:left-[0px]
                      lg:-translate-y-1/2
                    "
              >
                <div className="p-[5px] bg-[linear-gradient(135deg,#0086E6_0%,#8ABC00_100%)] inline-block">
                  {author?.image?.data?.attributes?.url && (
                    <Image
                      src={toWebp(
                        `${baseUrl}${author?.image?.data?.attributes?.url}`,
                      )}
                      alt="Author"
                      className="h-[180px] w-[189px] object-cover"
                      width={180}
                      height={180}
                    />
                  )}
                </div>
              </div>

              <div className="author-info pl-[0px] lg:pl-[24px]">
                <h2 className="text-center lg:text-left text-[#040405] font-[700] text-[24px] leading-[32.1px] md:text-[32px] md:leading-[41.6px] xl:text-[36px] xl:leading-[46.8px] mb-[12px]">
                  {author?.fullname ?? "John Doe"}
                </h2>
                <p className="text-center lg:text-left text-[#32343B] font-[400] md:text-[20px] md:leading-[28px] text-18px] leading-[25.2px]">
                  {author?.description ?? ""}
                </p>
                {author?.linked_in_url && (
                  <Link
                    href={author?.linked_in_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-medial mt-[12px] flex justify-center sm:justify-start md:w-[24px] md:h-[24px] w-[18px] h-[18px]"
                  >
                    <Image
                      src="/images/linkedin-blue.svg"
                      alt="LinkedIn"
                      width={24}
                      height={24}
                    />
                  </Link>
                )}
                {author?.link_tree_url && (
                  <Link
                    href={author?.link_tree_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-medial mt-[12px] flex justify-center sm:justify-start md:w-[24px] md:h-[24px] w-[18px] h-[18px]"
                  >
                    <Image
                      src="/images/linktree.svg"
                      alt="Linktree"
                      width={24}
                      height={24}
                    />
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogAuthor;
